export type ClassLesson = {
  id: string
  title: string
  type:
    | 'reading'
    | 'video'
    | 'assignment'
    | 'open_class_auto_graded_lab'
    | 'open_class_assignment'
    | 'open_class_quiz'
    | 'project'
  mark?: string
  status?: 'In progress' | 'Completed'
}

export type ClassModule = {
  id: string
  title: string
  lessons: ClassLesson[]
}

export type ClassCourse = {
  id: string
  title: string
  progress: number
  modules: ClassModule[]
}

export const classGradeLessonTypes = [
  'assignment',
  'open_class_auto_graded_lab',
  'open_class_assignment',
  'open_class_quiz',
  'project'
]

export const tempClassLessons: ClassLesson[] = [
  {
    id: 'g18wb7S2QWaeYRYb0FnxPQ',
    title: 'Lecture Note',
    type: 'reading'
  },
  {
    id: 'yShNTGgxTmWAWNdyrD5y1g',
    title: 'Programming Paradigm',
    type: 'video'
  },
  {
    id: 'qJdd79XJRxG_0LRmcAI4sw',
    title: 'Types of Programming',
    type: 'video'
  },
  {
    id: 'wUYIipCcTWSwb8he17Yr5g',
    title: 'Introduction to MIT App Inventor',
    type: 'open_class_quiz',
    mark: '70',
    status: 'Completed'
  },
  {
    id: 'Z4j8k4zGQD-_ETnoxKqtyw',
    title: 'MIT App Inventor - Mini Golf',
    type: 'open_class_quiz',
    status: 'In progress'
  }
]

export const tempClassModules: ClassModule[] = [
  {
    id: 'class-module-0',
    title: 'Experiencing Programming',
    lessons: tempClassLessons
  },
  {
    id: 'class-module-1',
    title: 'Introduction to Command Line',
    lessons: tempClassLessons
  },
  {
    id: 'class-module-2',
    title: 'Data Types',
    lessons: tempClassLessons
  },
  {
    id: 'class-module-3',
    title: 'Operators and Conditional Statements',
    lessons: tempClassLessons
  }
]

export const tempClassCourses: ClassCourse[] = [
  {
    id: 'class-course-0',
    title: 'Fundamentals of Javascript',
    progress: 50,
    modules: tempClassModules
  },
  {
    id: 'class-course-1',
    title: 'Web Programming Basics',
    progress: 0,
    modules: tempClassModules
  },
  {
    id: 'class-course-2',
    title: 'Introduction to Algorithms',
    progress: 0,
    modules: tempClassModules
  },
  {
    id: 'class-course-3',
    title: 'React Development',
    progress: 0,
    modules: tempClassModules
  },
  {
    id: 'class-course-4',
    title: 'Career Workshop',
    progress: 0,
    modules: tempClassModules
  }
]
